import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e983deb6")

_pushScopeId("data-v-e983deb6")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#target-container" }),
  /*#__PURE__*/_createTextVNode(" Target container ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" You can set "),
  /*#__PURE__*/_createVNode("code", null, "target"),
  /*#__PURE__*/_createTextVNode(" attribute to keep the affix in the container at all times. It will be hidden if out of range. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "affix-container" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Target container")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_affix = _resolveComponent("el-affix")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_el_affix, {
          target: ".affix-container",
          offset: 80
        }, {
          default: _withId(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
})